/**
 * Calcola il prezzo unitario di un articolo nel carrello/checkout.
 * Usa esclusivamente ``listino10`` — il prezzo reale del backend NTS.
 * Restituisce 0 se il campo non è valorizzato.
 */
export function getCartItemUnitPrice(item: { sku: string; listino10?: number | null }): number {
  if (typeof item.listino10 === 'number' && item.listino10 > 0) {
    return item.listino10;
  }
  return 0;
}
